import { render, staticRenderFns } from "./mallItemPerson.vue?vue&type=template&id=31c234b5&scoped=true&"
import script from "./mallItemPerson.vue?vue&type=script&lang=js&"
export * from "./mallItemPerson.vue?vue&type=script&lang=js&"
import style0 from "./mallItemPerson.vue?vue&type=style&index=0&id=31c234b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c234b5",
  null
  
)

export default component.exports